import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04daef9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = {
  key: 0,
  class: "offcanvas-header text-primary"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-full-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-in-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = { class: "h6 ms-16 mb-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-remove",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { class: "offcanvas-body" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-phone-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = { class: "fw-bold text-primary text-sm" }
const _hoisted_11 = {
  key: 2,
  class: "text-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-out-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close text-white",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = {
  key: 4,
  class: "text-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-phone-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_call = _resolveComponent("call")!

  return (_openBlock(), _createElementBlock("div", {
    id: "videocall-offcanvas",
    class: _normalizeClass(["offcanvas offcanvas-end show", {
    'maximized': !!_ctx.windowMaximized,
    'minimized': !!_ctx.windowMinimized,
    'normal ': !!_ctx.windowNormal,
  }]),
    tabindex: "-1",
    "aria-labelledby": _ctx.$t('Videollamada'),
    "aria-modal": "true",
    role: "dialog"
  }, [
    (!_ctx.windowMinimized)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!!_ctx.windowNormal)
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 0,
                type: "button",
                variant: "icon",
                class: "text-primary p-4",
                "aria-label": _ctx.$t('Expandir'),
                title: _ctx.$t('Expandir'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.windowMaximized = true; _ctx.windowNormal = false; _ctx.windowMinimized = false})
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (!!_ctx.windowMaximized)
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 1,
                type: "button",
                variant: "icon",
                class: "p-4",
                "aria-label": _ctx.$t('Modo ventana'),
                title: _ctx.$t('Modo ventana'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.windowMaximized = false; _ctx.windowNormal = true; _ctx.windowMinimized = false})
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('Videollamada con')) + " " + _toDisplayString(_ctx.currentExpedient.professional.name) + " " + _toDisplayString(_ctx.currentExpedient.professional.surname), 1),
          (!!_ctx.windowNormal)
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 2,
                type: "button",
                variant: "icon",
                class: "text-primary p-4",
                "aria-label": _ctx.$t('Minimizar'),
                title: _ctx.$t('Minimizar'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.windowMaximized = false; _ctx.windowNormal = false; _ctx.windowMinimized = true})
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.status === 'waiting' && !!_ctx.windowMinimized && _ctx.currentRoom)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createVNode(_component_v_button, {
                type: "button",
                variant: "icon",
                class: "text-primary text-xl p-4 me-8",
                "aria-label": _ctx.$t('Iniciar videollamada'),
                title: _ctx.$t('Iniciar videollamada'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.startVideocall(); _ctx.windowNormal = true; _ctx.windowMinimized = false})
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["aria-label", "title"])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Videoconsulta')), 1)
          ]))
        : (_ctx.status === 'loading')
          ? (_openBlock(), _createBlock(_component_v_loader, { key: 1 }))
          : (_ctx.status === 'loaded')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('Entrando en la videollamada...')), 1))
            : (_ctx.status === 'in-call')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (!!_ctx.windowMinimized)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_button, {
                          type: "button",
                          variant: "icon",
                          class: "text-primary p-4 me-8",
                          "aria-label": _ctx.$t('Modo ventana'),
                          title: _ctx.$t('Modo ventana'),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.windowMaximized = false; _ctx.windowNormal = true; _ctx.windowMinimized = false})
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }, 8, ["aria-label", "title"]),
                        _createVNode(_component_v_button, {
                          type: "button",
                          variant: "icon",
                          class: "btn-danger text-primary p-8",
                          "aria-label": _ctx.$t('Finalizar llamada'),
                          title: _ctx.$t('Finalizar llamada'),
                          onClick: _ctx.leaveCall
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["aria-label", "title", "onClick"])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["h-100", {'d-none': !!_ctx.windowMinimized}])
                  }, [
                    _createVNode(_component_call, {
                      leaveCall: _ctx.leaveCall,
                      name: _ctx.userName,
                      roomUrl: _ctx.roomUrl
                    }, null, 8, ["leaveCall", "name", "roomUrl"])
                  ], 2)
                ], 64))
              : (_ctx.status === 'idle' && !!_ctx.windowMinimized)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (!!_ctx.windowMinimized)
                      ? (_openBlock(), _createBlock(_component_v_button, {
                          key: 0,
                          type: "button",
                          variant: "icon",
                          class: "text-primary text-xl p-4 me-8",
                          "aria-label": _ctx.$t('Iniciar videollamada'),
                          title: _ctx.$t('Iniciar videollamada'),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.startVideocall(); _ctx.windowNormal = true; _ctx.windowMinimized = false})
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["aria-label", "title"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('Has salido de la videollamada.')), 1)
                  ]))
                : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}